import { render, staticRenderFns } from "./designProductDetails.vue?vue&type=template&id=c6ba74aa&scoped=true&"
import script from "./designProductDetails.vue?vue&type=script&lang=js&"
export * from "./designProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./designProductDetails.vue?vue&type=style&index=0&id=c6ba74aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ba74aa",
  null
  
)

export default component.exports